module.exports = __webpack_public_path__ + "media/images/logo-nsud-d508007c7b4429cfe66fde3bf685cbd5.png";